export function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, "");
}

export function joinIAiPublicServicePath(rootUrl: string, publicPath: string): string {
  const normalizedRootUrl = trimTrailingSlash(rootUrl);
  const normalizedPublicPath = publicPath.startsWith("/") ? publicPath : `/${publicPath}`;
  return `${normalizedRootUrl}${trimTrailingSlash(normalizedPublicPath)}`;
}

export function normalizeHostname(hostname?: string) {
  return String(hostname || "")
    .trim()
    .toLowerCase();
}

export function isLocalDevelopmentHost(hostname?: string) {
  const normalizedHostname = normalizeHostname(hostname);
  return normalizedHostname === "localhost" || normalizedHostname === "127.0.0.1";
}

export function resolveEffectiveHostname(hostname?: string) {
  const normalizedHostname = normalizeHostname(hostname);
  if (normalizedHostname) {
    return normalizedHostname;
  }
  if (typeof window !== "undefined") {
    return normalizeHostname(window.location.hostname);
  }
  return "";
}

export function formatIAiPublicUrlLabel(value: string) {
  const normalizedValue = trimTrailingSlash(String(value || "").trim());
  if (!normalizedValue) {
    return "";
  }
  try {
    const parsedUrl = new URL(normalizedValue);
    const normalizedPathname = trimTrailingSlash(parsedUrl.pathname);
    if (normalizedPathname && normalizedPathname !== "/") {
      return `${parsedUrl.host}${normalizedPathname}`;
    }
    return parsedUrl.host;
  } catch {
    return normalizedValue;
  }
}
